/**
 * Logto permissions on the billing API resource.  They are requested as scopes at sign-in, so Logto only puts these
 * in the access token, and /api/user returns the ones the user has.
 */
export const BILLING_PERMISSIONS = [
  'billing:all',
  'billing:view-afid-cascade-assignment',
  'billing:edit-afid-cascade-assignment',
  'billing:view-processors',
  'billing:edit-processors',
  'billing:view-campaign-price',
  'billing:edit-campaign-price',
  'billing:edit-signup-caps',
  'billing:update-accounts',
  'billing:rdr-import',
] as const;

export type BillingPermission = typeof BILLING_PERMISSIONS[number];

/**
 * Grants every other billing permission.
 */
export const SUPERUSER_PERMISSION: BillingPermission = 'billing:all';
